import { render, staticRenderFns } from "./ListPatients.vue?vue&type=template&id=956d1bc8&scoped=true&"
import script from "./ListPatients.vue?vue&type=script&lang=js&"
export * from "./ListPatients.vue?vue&type=script&lang=js&"
import style0 from "./ListPatients.vue?vue&type=style&index=0&id=956d1bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956d1bc8",
  null
  
)

export default component.exports